import React from 'react';
import Navbar from '../components/Navbar';
import ProductCard from '../components/ProductCard'; // Assuming you have a ProductCard component similar to ServiceCard
import './Products.css'; // Add necessary CSS for styling

function Products() {
  // Data for the products
  const products = [
    {
      title: 'NGINX-based WAF (C++ Module)',
      description: 'The NGINX-based WAF is a custom module for NGINX written in C++ that provides advanced Web Application Firewall (WAF) protection. It effectively detects and mitigates various web-based attacks, including SQL Injection, Cross-Site Scripting (XSS), and Remote Command Execution (RCE). Designed for high-performance environments, this module offers protocol attack protection, secure session management, and comprehensive rules to safeguard your web applications. It can be integrated as either a static or dynamic module with NGINX, with extensive configuration options for tailored security.',
      link: 'https://github.com/cloudrhinoltd/ngx-waf-protect',
    },
    {
      title: 'Redis-Proxy (Go)',
      description: 'Redis-Proxy is a Go-based proxy server designed to secure multi-client access to Redis. It isolates clients with unique credentials, managing access through Redis database indices. Optimized for container environments like Kubernetes, Redis-Proxy uses service accounts and environment variables for configuration, providing robust client isolation and secure command handling. It ensures high performance and security for Redis deployments, making it ideal for scalable applications.',
      link: 'https://github.com/cloudrhinoltd/redis-proxy',
    },
    {
      title: 'Custom Ingress-Controller with WAF',
      description: 'This Custom Ingress-Controller is built on a custom NGINX version with an integrated WAF module, providing advanced ingress traffic management with built-in web security features. Tailored for Kubernetes, it combines robust threat protection against attacks like SQL Injection, XSS, and RCE with the latest SSL3 libraries and modern security compliance. It offers a scalable solution for managing ingress traffic and enhancing web application security in cloud-native environments.',
      link: 'https://github.com/cloudrhinoltd/nginx-ingress',
    },
    {
      title: 'Extended Infinity-Plus Datasource',
      description: 'The Extended Infinity-Plus Datasource is a sophisticated extension of the Grafana Infinity Datasource that includes MSI authentication for secure data access. It supports versatile data integration for Grafana dashboards, leveraging Azure\'s identity management services to enhance security. This extension is designed for complex data visualization needs, providing robust and secure data handling capabilities suitable for enterprise environments.',
      link: 'https://github.com/cloudrhinoltd/infinity-plus-datasource',
    },
  ];

  return (
    <div>
      <Navbar />
      <main className="products-section">
        <h1>Our Products</h1>
        <p>
          At Cloud Rhino, we offer a range of advanced cybersecurity products designed to protect your digital assets from evolving threats. Our products are developed using cutting-edge technology and are tailored to meet the unique security needs of businesses in various industries.
        </p>
        <div className="products-grid">
          {products.map((product, index) => (
            <ProductCard
              key={index}
              title={product.title}
              description={product.description}
              link={product.link} // Pass the link for users to read more or download
            />
          ))}
        </div>
        <p>
          Explore our products to find the right cybersecurity solutions for your business. Partner with Cloud Rhino to fortify your digital presence with our innovative security technologies.
        </p>
      </main>
    </div>
  );
}

export default Products;
